<template lang="html">
  <div id="formulas-view">
    <div class="formulas-header">
      <b>What conversions do you want to look at?</b>
    </div>

    <div class="formulas" v-for="(formula, id) in newFormulas" :key="id">
      <FormulaEditor :formula="formula"/>
      <i class="fas fa-pen edit" v-show="!formula.editing" @click="formula.editing=true"></i>
      <i class="fas fa-check save" v-show="formula.editing" @click="formula.editing=false"></i>
      <i class="fas fa-times remove" @click="newFormulas.splice(id, 1);"></i>
    </div>

    <button type="button" class="btn add" @click="addFormula" v-show="newFormulas.filter(f=>f.editing==true).length == 0" >&#10010;</button>

    <div class="btn-holder">
      <button type="button" class="btn apply" @click="apply">Apply</button>
    </div>
  </div>
</template>

<script>
import FormulaEditor from '@/components/FormulaEditor'
import store from "@/store/store.js"
import API from '@/resources/API.js';
export default {
  components: {
    FormulaEditor,
  },
  props: {
    hide: {
      type: Function,
      required: true,
    }
  },
  data() {
    return {
      newFormulas: store.state.formulas.map((f) => {
        return {
          name: f.name,
          equation: f.equation,
          editing: false
        }
      }),
    }
  },
  methods: {
    addFormula() {
      this.newFormulas.push({
        name: '',
        equation: '',
        editing: true
      })
    },
    apply() {
      //TODO: Validate formulas! How??
      var fs = []
      this.newFormulas.forEach(f => {
        f.editing = false
        fs.push({
          name: f.name,
          equation: f.equation,
        })
      })

      var events = store.state.events
      var eventsToRequest = []
      for (var i = 0; i < events.length; i++) {
        if (events[i].toAdd || events[i].isPresent && !events[i].toRemove) {
          eventsToRequest.push(events[i].name)
        }
      }

      var featuresToRequest = []
      var features = store.state.features
      for (var j = 0; j < features.length; j++) {
        if (features[j].toAdd || features[j].isPresent && !features[j].toRemove) {
          featuresToRequest.push(features[j].name)
        }
      }

      API.SaveUpcomingState({
        sandbox: store.state.sandbox,
        precision: store.state.precision,
        cohort: store.state.cohort,
        filter: store.state.filter,
        dates: store.state.dates,
        selectedBundles: store.state.selectedBundles,
        events: eventsToRequest,
        features: featuresToRequest,
        formulas: fs,
      }, store.getters.getHash)

      console.log(fs);
      store.commit('updateState', {
        formulas: fs
      })
      this.hide()
    },
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css">

</style><style lang="scss">@import '../assets/variables.scss';
#formulas-view {
  margin: 20px;
  height: 90%;
  position: relative;
  .formulas {
    display: flex;
    flex-direction: row;
    .fas {
      align-items: center;
      display: inline-flex;
    }
    .fas {
      margin-left: 10px;
      &:hover {
        cursor: pointer;
      }
      &.remove {
        color: $red;
      }
      &.save {
        color: $green;
      }
    }
  }
  .formulas-header {
    margin: 0 10px 20px;
  }

  .btn-holder {
    width: 100%;
    bottom: 7px;
    text-align: center;
    position: absolute;
  }
  
  .btn {
    border: none;
    font-size: 14px;
    background-color: white;
    &:hover {
      cursor: pointer;
    }
    &.add {
      margin-top: 10px;
      color: $green;
      font-size: 18px;
      float: left;
    }
    &.apply {
      font-weight: bold;
      width: 200px;
      height: 40px;
      border-radius: 20px;
      border-color: $blue;
      border-width: 2px;
      border-style: solid; // background-color: $blue;
      color: black;
      font-size: 16px;
      &:hover {
        filter: brightness(95%);
      }
    }
  }
}
</style>
